import React from 'react';
import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import {Container} from 'react-bootstrap';
import DocumentsManager from './DocumentsManager';
import {useGetMe} from '../../hooks/useGetMe';
import {isClientCIS} from '../../../Domains/Auth/Utils/CustomerHelper';
import ComingSoon from '../../common/components/ComingSoon';

const Documents = () => {
    const intl = useIntl();
    const customer = useGetMe();

    return (
        <Container className="h-100 p-0" fluid={true}>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.MY_ACCOUNT'})}</PageTitle>
            {isClientCIS(customer) ? <DocumentsManager /> : <ComingSoon />}
        </Container>
    );
};

export default Documents;
